import type * as Y from 'yjs';
import { toBoardFile, type BoardFile } from '@os/doc';

/** `maison-lumiere-2026-11-01.osboard`: the title without accents or punctuation, and the UTC day. */
export function exportFileName(title: string, ext: string, at = new Date()): string {
  const slug =
    title
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60)
      .replace(/-+$/, '') || 'board';
  return `${slug}-${at.toISOString().slice(0, 10)}.${ext}`;
}

/** The refused-edits banner's file (spec §7.3 #10): this device's copy as a `BoardFile`, without assets. */
export function offlineCopy(doc: Y.Doc, title: string, at = new Date()): { name: string; data: BoardFile } {
  return { name: exportFileName(title, 'json', at), data: toBoardFile(doc, { title, exportedAt: at.toISOString(), assets: [] }) };
}
